<template>
    <div class="app-body-container" style="padding-bottom: 30px">

        <el-row class="mg-t-10">
            <el-col :span="24">
                <el-card shadow="hover" class="mycard-a">

                    <!--按单号查询-->
                    <div class="query-box">
                        <el-form :inline="true" class="myform">
                            <el-form-item>
                                <span class="mycard-title" style="margin-right: 30px">按单号查询</span>
                            </el-form-item>
                            <el-form-item>
                                <el-input placeholder="输入单号" style="width:325px" v-model="main$query_dealNo">
                                  <el-select v-model="main$query_dealType" slot="prepend" placeholder="请选择" style="width: 120px">
                                    <el-option label="订单号" value="1"></el-option>
                                    <el-option label="退货单号" value="2"></el-option>
                                    <el-option label="物流单号" value="3"></el-option>
                                  </el-select>
                                </el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" class="mybtn" @click="fetchData">查询</el-button>
                                <el-button type="text" class="mybtn" @click="main$querys = true">高级筛选</el-button>
                            </el-form-item>
                        </el-form>
                    </div>

                  <el-dialog
                    title="提示"
                    :visible.sync="main$querys"
                    class="mydialog" :append-to-body="true">
                    <!--按条件查询-->
                    <div class="query-box">
                      <div class="mycard-title">
                        按条件查询
                      </div>
                      <el-form label-width="100px" class="flex" style="margin-top: 20px">
                        <el-form-item label="开始时间">
                          <el-date-picker
                            v-model="main$query_startdate"
                            type="date"
                            placeholder="请选择">
                          </el-date-picker>
                        </el-form-item>
                        <el-form-item label="结束时间">
                          <el-date-picker
                            v-model="main$query_enddate"
                            type="date"
                            placeholder="请选择">
                          </el-date-picker>
                        </el-form-item>
                      </el-form>
                      <el-form label-width="100px" class="flex">

                        <el-form-item label="客户">
                          <el-input placeholder="请输入" v-model="main$query_buyerName"></el-input>
                        </el-form-item>
                        <el-form-item label="销售员">
                          <el-input placeholder="请输入" v-model="main$query_salesmanName"></el-input>
                        </el-form-item>
                      </el-form>
                      <el-form label-width="100px" class="flex">

                        <el-form-item label="订单状态">
                          <el-select v-model="main$query_states" placeholder="请选择">
                            <el-option v-for="(item,idx) in data_states" :key="idx" :label="item.value" :value="item.code"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="支付状态">
                          <el-select v-model="main$query_payStatus" placeholder="请选择">
                            <el-option label="已支付" value="1"></el-option>
                            <el-option label="未支付" value="0"></el-option>
                          </el-select>
                        </el-form-item>
                      </el-form>
                      <el-form label-width="100px" class="flex">

                        <el-form-item label="来源">
                          <el-select v-model="main$query_dataSource" placeholder="请选择">
                            <el-option v-for="(item,idx) in data_dataSource" :key="idx"  :label="item.value" :value="item.code"></el-option>
                          </el-select>
                        </el-form-item>
                      </el-form>
                    </div>

                  </el-dialog>

                    <!--订单记录(标题)-->
                    <div class="mycard-title" style="margin-bottom: 20px">
                        订单记录
                        <el-popover placement="right" width="360" trigger="hover">
                            <div>
                                订单列表默认显示近30天的订单数据，若想查看更多订单，请按条件查询
                            </div>
                            <i class="iconfont iconft-question mycard-title-icon" slot="reference"></i>
                        </el-popover>
                    </div>

                    <!--订单记录(表格)-->
                    <el-table :data="main$data" v-loading="main$loading" size="medium">
                        <el-table-column prop="dealNo" label="单号" width="180" align="center" header-align="center"> </el-table-column>
                        <el-table-column prop="dd1" label="时间" width="160" align="center" header-align="center"> </el-table-column>
                        <!--<el-table-column prop="xxxxxxxx" label="类型" width="90" align="center" header-align="center"> </el-table-column>-->
                        <el-table-column prop="buyerName" label="客户" show-overflow-tooltip width="200" align="center" header-align="center"> </el-table-column>
                        <el-table-column prop="dataSourceStr" label="来源" width="120" align="center" header-align="center"> </el-table-column>
                        <el-table-column prop="salesmanName" label="销售员" width="120" align="center" header-align="center"> </el-table-column>
                        <el-table-column prop="statesCn" label="状态" width="120" align="center" header-align="center"> </el-table-column>
                        <el-table-column label="操作" align="center" header-align="center">
                            <template slot-scope="scope">
                                <el-button type="text" class="mylinkbtn" @click="table_detail(scope.row.id)">详情</el-button>
                            </template>
                        </el-table-column>
                    </el-table>

                    <!--订单记录(分页)-->
                    <div style="margin: 14px">
                        <el-pagination style="float: right"
                                       layout="total, sizes, prev, pager, next"
                                       :page-size="main$page_size"
                                       :current-page="main$curr_page"
                                       :total="main$total"
                                        @current-change="handlePageChange"></el-pagination>
                        <div style="clear: both"></div>
                    </div>

                </el-card>
            </el-col>
        </el-row>

      <!--订单详情-->
      <el-dialog title="订单详情" :visible.sync="orderDetails" width="80%" class="mydialog mydialog_add_order_group" :append-to-body="true">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" style="margin-bottom: 60px">
          <el-row>
            <el-col :lg="8"><el-form-item label="订单号"><span>{{ruleForm.orderDetails.deal_no}}</span></el-form-item></el-col>
            <el-col :lg="8"><el-form-item label="下单时间"><span>{{parseFloat(ruleForm.orderDetails.dd1) | formatConversion(1)}}</span></el-form-item></el-col>
            <el-col :lg="8">
              <el-form-item label="订单来源">
                <div v-if="ruleForm.orderDetails.origin_id==3"><span style="color: #E6A23C">【代】</span>{{ruleForm.orderDetails.creator}}</div>
                <div v-if="ruleForm.orderDetails.origin_id==2"><span style="color: #409EFF">【业】</span>{{ruleForm.orderDetails.salesman_name}}</div>
                <div v-if="ruleForm.orderDetails.origin_id==1"><span style="color: #67C23A">【店】</span>{{ruleForm.orderDetails.ship_name}}</div>
              </el-form-item>
            </el-col>
            <el-col :lg="8">
              <el-form-item label="客户信息">
                <span>{{ruleForm.orderDetails.buyer_name}} {{ruleForm.orderDetails.ship_name}} {{ruleForm.orderDetails.ship_mob}}</span>
              </el-form-item>
            </el-col>
            <el-col :lg="8"><el-form-item label="配送方式"><span>{{ruleForm.orderDetails.csg_way_cn}}</span></el-form-item></el-col>
            <el-col :lg="8"><el-form-item label="支付方式"><span>{{ruleForm.orderDetails.pay_type_cn}}</span></el-form-item></el-col>
            <el-col :lg="8"><el-form-item label="收货地址 "><span>{{ruleForm.orderDetails.ship_addrs}}</span></el-form-item></el-col>
            <el-col :lg="8"><el-form-item label="订单状态"><span>{{ruleForm.orderDetails.states_cn}}</span></el-form-item></el-col>
            <el-col :lg="8"><el-form-item label="付款状态"><span>{{ruleForm.orderDetails.pay_status_cn}}</span></el-form-item></el-col>
            <el-col :lg="8"><el-form-item label="备注"><span>{{ruleForm.orderDetails.remark_s}}</span></el-form-item></el-col>
            <el-col :lg="8" v-if="ruleForm.orderDetails.flat_id==3">
              <el-form-item label="买方留言"><p></p>{{ruleForm.orderDetails.remark_b}}</el-form-item>
            </el-col>
          </el-row>
          <el-table
            ref="multipleTable"
            :data="tableDataList"
            tooltip-effect="dark"
            style="width: 100%"
            border
            size="medium">
            <el-table-column show-overflow-tooltip align="center" header-align="center" :prop="item.key" :label="item.name" v-for="(item,i) in listDetails" :key="i"></el-table-column>
          </el-table>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="orderDetails=false">取消</el-button>
        </div>
      </el-dialog>
    </div>
</template>

<script>
import {formatDate} from '@/common/filters'
export default {
    data: function () {
        return {
            orderDetails:false, //订单详情弹框
            data_states:[],         // 下拉框：订单状态
            data_dataSource:[],     // 下拉框：数据来源
            main$query_dealType:'',      // 单据类型
            main$query_dealNo: '',       // 订单编号
            main$query_startdate: '',   // 开始日期
            main$query_enddate: '',     // 结束日期
            main$query_buyerName: '',   // 客户名称
            main$query_salesmanName: '',// 销售员姓名
            main$query_states: '',      // 订单状态 1待审核
            main$query_payStatus: '',   // 支付状态 0未支付 1已支付
            main$query_dataSource: '',  // 数据来源 01-逍逍
            main$querys:false,
            main$page_size: 10,
            main$curr_page: 1,
            main$loading: false,
            main$total: 0,
            main$data: [],

            ruleForm: {
              orderDetails:{}, //订单详情
            },
            tableDataList: [], //数据列表
            listDetails:[
              {name:'货号', key:"gcode"},
              {name:'商品名称', key:"goods_name"},
              {name:'规格', key:"spec_name"},
              {name:'单位', key:"unit_name"},
              {name:'条码', key:"barcode"},
              {name:'数量', key:"amount"},
              {name:'单价', key:"price"},
              {name:'小计', key:"total_fee"},
              {name:'备注', key:"remark"},
            ],
        }
    },
    methods: {
        handleClose(done) {
          this.$confirm('确认关闭？')
            .then(_ => {
              done();
            })
            .catch(_ => {});
        },
        fetchData: function(){
            let self = this;

            let post = {
                "page": self.main$curr_page,//分页页数
                "rows": self.main$page_size,//分页大小
                "dataSource": self.main$query_dataSource,//数据来源
                "dealType": self.main$query_dealType,//单据类型
                "dealNo": self.main$query_dealNo,//订单编号
                "buyerName": self.main$query_buyerName,//客户名称
                "salesmanName": self.main$query_salesmanName,//销售员姓名
                "states": self.main$query_states,//订单状态
                "payStatus": self.main$query_payStatus,//支付状态 0未支付 1已支付
            }

            if(post.dealNo && !post.dealType){
                self.xEui.msg_error('请选择单号类型')
                return
            }

            if(self.main$query_startdate){
                post.begin = formatDate(self.main$query_startdate);
            }

            if(self.main$query_enddate){
                post.end = formatDate(self.main$query_enddate);
            }

            self.main$loading = true
            self.xFetch.post(self.xApi('/robot/order/getOrderList'), post).then(function (res) {
                self.main$loading = false

                if (res.data.code != '00') {
                    self.xEui.msg_error(res.data.text)
                    self.main$total = 0;
                    self.main$data = [];
                }
                else {
                    self.main$total = res.data.total;
                    self.main$data = res.data.rows;
                }
            });
        },
        handlePageChange: function (val) {
            this.main$curr_page = val;
            this.fetchData();
        },
        table_detail: function(id){
          let self=this;
          let user = localStorage.getItem('sysale-robot$user');
          user = JSON.parse(user);
          self.xFetch.post(self.xApi('/xx_admin/deal.DhDealMgr/getDealInfo?sessionid='+user.data.sessionid), {deal_id:parseFloat(id)}).then(function (res) {
//            console.log(res)
            if(res.data.ret_status='ok'){
              self.ruleForm.orderDetails=res.data;
            }
          });
          self.xFetch.post(self.xApi('/xx_admin/deal.DhDealMgr/getDealGoods?sessionid='+user.data.sessionid), {deal_id:parseFloat(id)}).then(function (res) {
//            console.log(res)
            if(res.data.ret_status='ok'){
              for(let i of res.data.goods_list){
                i.price=self.numMulti(i.price,0.01);
                i.total_fee=self.numMulti(i.total_fee,0.01);
              }
              self.tableDataList=res.data.goods_list;
            }
          });
          self.orderDetails=true;
        },
        //乘法运算 避免数据相乘小数点后产生多位数和计算精度损失
        numMulti(num1, num2) {
          let baseNum = 0;
          try {
            baseNum += num1.toString().split(".")[1].length;
          } catch (e) {
          }
          try {
            baseNum += num2.toString().split(".")[1].length;
          } catch (e) {
          }
          return Number(num1.toString().replace(".", "")) * Number(num2.toString().replace(".", "")) / Math.pow(10, baseNum);
        },
        table_cancel: function (id) {
          // ×
          this.xEui.msg_success('取消订单')
        },
    },
    created: function () {
        let self = this

        // 下拉框订单状态、数据来源
        self.xFetch.post(self.xApi('/robot/common/getOrderStates'), {}).then(function (res) {
            if (res.data.code != '00') {
                self.xEui.msg_error(res.data.text)
                return
            }
            self.data_states = res.data.data;
        });
        self.xFetch.post(self.xApi('/robot/common/getDataSource'), {}).then(function (res) {
            if (res.data.code != '00') {
                self.xEui.msg_error(res.data.text)
                return
            }
            self.data_dataSource = res.data.data;
        });

        // 加载表数据
        self.fetchData();
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .el-input, .el-select, .el-date-editor.el-input{
      width: 220px;
    }
    .mycard-title{ color: #333 }
    .mycard-title .mycard-title-icon{ font-size: 18px;position: relative;top: -5px }
    /*query-box*/
    .query-box{ border-bottom: 1px solid #F0F2F5;padding-bottom: 20px;margin-bottom: 20px }
    .flex{display: flex;justify-content: space-between;align-items: center}
</style>



// WEBPACK FOOTER //
// src/views/order/record.vue